import { Slot } from 'app/routx-router'
import AuthenticatedLayout from 'app/src/layouts/AuthenticatedLayout'
import MenuLayout from 'app/src/layouts/MenuLayout'
import ProtectedRoute from 'app/src/layouts/ProtectedRoute'

interface DiscoverMenuLayoutProps {
  isHome?: boolean
  title?: string
}

const DiscoverMenuLayout: FC<DiscoverMenuLayoutProps> = () => {
  return (
    <ProtectedRoute>
      <AuthenticatedLayout>
        <MenuLayout>
          <Flex $p={'lg'} $flexDirection='column' $flex={1} $maxWidth={980} $mx='auto'>
            <Slot />
          </Flex>
        </MenuLayout>
      </AuthenticatedLayout>
    </ProtectedRoute>
  )
}

export const Component = DiscoverMenuLayout
export default DiscoverMenuLayout
